<ng-container *ngIf="selectedVenue; else noData">
<iframe  [style.height]="innerHeight" id="MyHeadquartersIframe" style="width: 100%;" [src]="myBranchUrl | safe" title="My Branch"></iframe>
</ng-container>
<ng-template #noData>
    <header class="noData">
      <h1>{{ "PLANNER.NO_ORDERS" | translate }}</h1>
    </header>
  </ng-template>

